import { Md5 } from 'ts-md5/dist/md5';
import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des tiers (utilisateurs)
 */
@Injectable()
export class TiersService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /** Session en cours */
  public h_currentUser: any;

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);

    //Cas spécifique, car service accessible depuis la page register
    //donc sans être logué. Et sur rechargement (F5), le appSettings
    //est chargé après la construction de ce service
    if (this.s_global.pathAPI === "pathAPI") {
      this.s_appsettings.proc_getSettings().subscribe(settings => {
        this.s_global.pathAPI = settings.pathAPI;
        this.w_baseUrl = this.s_global.pathAPI + "/tiers";
      });
    } else this.w_baseUrl = this.s_global.pathAPI + "/tiers";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de recuperation de tous les tiers
   * Retour : json avec la liste de tous les tiers
   *
   */
  public proc_getAll(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getall`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'un tiers par son id
   * Parametres : tiersId du tiers
   * Retour : json avec le tiers
   *
   */
  public proc_get(id: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/${id}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation du tiers de l'utilisateur actuel
   * Retour : json avec le tiers
   *
   */
  public proc_getTiersByToken(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getTiersByToken`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'un tiers par son id au format MD5
   * Parametres : tiersId au format MD5 du tiers
   * Retour : json avec le tiers
   *
   */
  public proc_getTiersbyMd5id(id: String): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/cdg/${id}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'un tiers dans la BDD
   * Parametres : tiers a ajouter
   *
   */
  public proc_add(h_tiers: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/add`,
      JSON.stringify({
        tiers: JSON.stringify(h_tiers),
        msg_titre: this.s_appsettings.proc_getTraduction(
          "API_tiers.mail_titre_add"
        ),
        msg_lig1: this.s_appsettings.proc_getTraduction(
          "API_tiers.mail_msg_add"
        )
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'un tiers dans la BDD
   * Parametres : tiers a ajouter
   *
   */
  public proc_register(h_tiers: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/register`,
      JSON.stringify({
        tiers: JSON.stringify(h_tiers),
        msg_titre: this.s_appsettings.proc_getTraduction(
          "API_tiers.mail_titre_add"
        ),
        msg_lig1: this.s_appsettings.proc_getTraduction(
          "API_tiers.mail_msg_add"
        )
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de mise a jour du mot de passe actuel d'un tiers
   * Parametres : ancien et nouveau mot de passe
   *
   */
  public proc_updateMDP(
    oldpassword: string,
    newpassword: string
  ): Observable<any> {
    this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));

    return this.http.post(
      `${this.w_baseUrl}/updateMDP`,
      JSON.stringify({
        oldpassword: Md5.hashStr(oldpassword),
        newpassword: Md5.hashStr(newpassword),
        token: this.h_currentUser.token,
        msg_titre: this.s_appsettings.proc_getTraduction(
          "API_tiers.mail_titre_updateMDP"
        ),
        msg_lig1: this.s_appsettings.proc_getTraduction(
          "API_tiers.mail_msg_updateMDP"
        )
      }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de mise a jour d'un tiers dans la BDD
   * Parametres : tiers a modifier
   *
   */
  public proc_update(tiers: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/update`,
      JSON.stringify(tiers),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation du tiersId au format MD5 de l'utilisateur actuel
   * Retour : json avec le tiersId au format MD5
   *
   */
  public proc_getTiersIdMD5(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getTiersIdMD5`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation des listes des tiers appartenant a la grappe de l'utilisateur et des tiers CDG auquel appartient l'utilisateur
   * Retour : json avec la liste des tiers
   *
   */
  public proc_getListTiersGrappe(i_chefgrappe: number): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getListTiersGrappe`,
      i_chefgrappe,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de suppression d'un tiers dans la BDD
   * Parametres : tiers a ajouter
   */
  public proc_delete(tiers: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/delete`,
      JSON.stringify(tiers),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/tiers.service.ts